<template>
	<div style="height: calc(100vh - 130px);">
		<div class="amountOfStatistical" >
			<div class="amisarda">财政浏览</div>
	    	<div class="scroll-div" id="amountOfStatistical" >
					<div class="tag-defined">
						<div class="icon-arrow-left pointer" style="height:100px;line-height:100px;" v-show="statisticScrollLeftShow" @click="scrollLeft('amountOfStatistical')">
								<i class="el-icon-arrow-left"></i>
						</div>
			    	<div class="amountOfStatisticalItem" v-for="(item,index) in dataList" :key="index">
							<el-row>
								<el-col :span="6" style="text-align:center;padding-top:16px;">
									<img :src="require('../../assets/img/' + item.icon)" width="48px"/>
								</el-col>
								<el-col :span="18">
									<div class='amountOfStatisticalItem-right'>
										<h2>{{item.label}}</h2>
										<p>{{item.tip}}</p>
										<h1>{{money_format(item.value/100,2)}}</h1>
									</div>
								</el-col>
							</el-row>
			    	</div>
			    	<div class="icon-arrow-right pointer" style="height:100px;line-height:100px;" v-show="statisticScrollRightShow" @click="scrollRight('amountOfStatistical')">
							<i class="el-icon-arrow-right"></i>
						</div>
					</div>
				</div>
	    </div>
			<div class="amisarda" style="margin-top:30px;">财政详情</div>
			<el-row class="cardStatistical-row" id="cardStatistical">
				<div class="icon-arrow-left pointer" style="height: 148px;" v-show="statisticScrollLeftShowSecond" @click="scrollLeftSecond('cardStatistical')">
					<i class="el-icon-arrow-left"></i>
				</div>
				<el-col :span="12">
					<div class="grid-content">
						<div class="title">卡板管理</div>
						<div class="amountOfStatistical-bottom">
							<div class="amountOfStatistical-bottom-item">
								<p>{{topData.simTotalCount}}</p>
								<h2>卡板总数</h2>
							</div>
							<div class="amountOfStatistical-bottom-item">
								<p>{{topData.simAlreadySold}}</p>
								<h2>激活卡数</h2>
							</div>
							<div class="amountOfStatistical-bottom-item">
								<p>{{topData.simNotSold}}</p>
								<h2>在用卡数</h2>
							</div>
							</div>
					</div>
				</el-col>
				<el-col :span="12">
					<div class="grid-content">
						<div class="title">代理管理</div>
						<div class="amountOfStatistical-bottom">
							<div class="amountOfStatistical-bottom-item">
								<p>{{topData.agentTotalCount}}</p>
								<h2>代理总数</h2>
							</div>
							<div class="amountOfStatistical-bottom-item">
								<p>{{topData.agentAlreadyInvest}}</p>
								<h2>直属代理</h2>
							</div>
							<div class="amountOfStatistical-bottom-item">
								<p>{{topData.agentNotInvest}}</p>
								<h2>今日新增</h2>
							</div>
						</div>
					</div>
				</el-col>
				<el-col :span="12">
					<div class="grid-content">
						<div class="title">佣金订单</div>
						<div class="amountOfStatistical-bottom">
							<div class="amountOfStatistical-bottom-item">
								<p>{{number_format(topData.orderMonthCount, 2)}}</p>
								<h2>订单总数</h2>
							</div>
							<div class="amountOfStatistical-bottom-item">
								<p>{{number_format(topData.backOrderMonthCount, 2)}}</p>
								<h2>本月订单</h2>
							</div>
							<div class="amountOfStatistical-bottom-item">
								<p>{{number_format(topData.orderUpMonthCount, 2)}}</p>
								<h2>今日新增</h2>
							</div>
						</div>
					</div>
				</el-col>
				<el-col :span="12">
					<div class="grid-content">
						<div class="title">销售金额</div>
						<div class="amountOfStatistical-bottom">
							<div class="amountOfStatistical-bottom-item">
								<p>{{money_format(topData.orderMoneyMonthCount, 2)}}</p>
								<h2>订单总额</h2>
							</div>
							<div class="amountOfStatistical-bottom-item">
								<p>{{money_format(topData.backOrderMoneyMoneyCount, 2)}}</p>
								<h2>本月总额</h2>
							</div>
							<div class="amountOfStatistical-bottom-item">
								<p>{{money_format(topData.orderUpMonthCounts, 2)}}</p>
								<h2>今日新增</h2>
							</div>
						</div>
					</div>
				</el-col>
				<div class="icon-arrow-right pointer" style="height: 148px;" v-show="statisticScrollRightShowSecond" @click="scrollRightSecond('cardStatistical')">
					<i class="el-icon-arrow-right"></i>
				</div>
			</el-row>
	</div>





</template>

<script>
import {agentDataStatistics,agentDataStatistics1 } from '@/api/home.js'
import common from '@/utils/common.js'
const echarts = require('echarts');      // 引入 ECharts 主模块
export default {
	data(){
		return {
			topData:{},
			historyData:[],
			historyTableData:[],
			dataList:	[
				// {icon:'icon08.png',label:'总佣金（元）',tip:'',value:'commissionTotalCount'},
				// {icon:'icon09.png',label:'本月佣金（元）',tip:'',value:'commissionMonthCount'},
				// {icon:'icon11.png',label:'我的佣金（元）',tip:'',value:'myCommission'},
				// {icon:'icon08.png',label:'本月订单总额（元）',tip:'',value:'orderMoneyMonthCount'},
			
			],
			orderTime : [], //订单时间
			weekNumber : [], //订单数
			weekMoney : [],//订单金额
			maxWeekNumber : 0,//最大订单数
			maxWeekMoney : 0,//最大订单金额
			option : {},
			myChart : {},
			//滚动数据
			scrollValOne: 0,
			statisticScrollLeftShow: false,
			statisticScrollRightShow: false,

			scrollValSecond: 0,
			statisticScrollLeftShowSecond: false,
			statisticScrollRightShowSecond: false,
		}
	},
	methods: {
		getDataHandle($event){
			agentDataStatistics1().then(res => {
				if(res.data.code == 200){
					this.topData=res.data.data;
					this.dataList=res.data.data.dataList;
				}else{
					this.$message.error(res.data.msg);
				}
			}).catch(err=>console.error(err));
		},
		//取数组最大值
		getMax(array){
			var min = array[0], max=array[0];
			for (let i = 0; i <= array.length; i++) {
				var cur = array[i];
				cur > max ? max = cur:null;
				cur < min ? min = cur:null;
			}
			return max;
		},
		scrollLeft(element){
			let w = document.getElementById(element).clientWidth || document.getElementById(element).offsetWidth;
			if(this.scrollValOne >= document.getElementById(element).scrollWidth){
				this.scrollValOne = document.getElementById(element).scrollWidth - w - w/2;
			}else if(this.scrollValOne > 0){
				this.scrollValOne = this.scrollValOne - w;
			}
			if(this.scrollValOne <= 0){
				this.scrollValOne = 0;
				this.statisticScrollLeftShow = false;
			}
			document.getElementById(element).scrollTo({ 
				left: this.scrollValOne, 
				behavior: "smooth" 
			});
			this.statisticScrollRightShow = true;
		},
		scrollRight(element){
			let w = document.getElementById(element).clientWidth||document.getElementById(element).offsetWidth;
			if(document.getElementById(element).scrollWidth - this.scrollValOne <= w+w/2){
					this.scrollValOne = document.getElementById(element).scrollWidth;
			}else{
					this.scrollValOne = this.scrollValOne + w/2;
			}
			if(this.scrollValOne >= document.getElementById(element).scrollWidth){
				this.scrollValOne = document.getElementById(element).scrollWidth
				this.statisticScrollRightShow = false;
			}
			document.getElementById(element).scrollTo({ 
				left: this.scrollValOne, 
				behavior: "smooth" 
			});
			this.statisticScrollLeftShow = true;
		},
		scrollLeftSecond(element){
			let w = document.getElementById(element).clientWidth || document.getElementById(element).offsetWidth;
			if(this.scrollValSecond >= document.getElementById(element).scrollWidth){
					this.scrollValSecond = document.getElementById(element).scrollWidth - w - w/2;
			}
			else if(this.scrollValSecond > 0){
					this.scrollValSecond = this.scrollValSecond - w;
			}
			if(this.scrollValSecond <= 0){
					this.scrollValSecond = 0;
					this.statisticScrollLeftShowSecond = false;
			}

			document.getElementById(element).scrollTo({ 
					left: this.scrollValSecond, 
					behavior: "smooth" 
			});

			this.statisticScrollRightShowSecond = true;
		},
		scrollRightSecond(element){
			let w = document.getElementById(element).clientWidth||document.getElementById(element).offsetWidth;
			if(document.getElementById(element).scrollWidth - this.scrollValSecond <= w+w/2){
					this.scrollValSecond = document.getElementById(element).scrollWidth;
			}else{
					this.scrollValSecond = this.scrollValSecond + w/2;
			}
			if(this.scrollValSecond >= document.getElementById(element).scrollWidth){
				this.scrollValSecond = document.getElementById(element).scrollWidth
				this.statisticScrollRightShowSecond = false;
			}
			document.getElementById(element).scrollTo({ 
				left: this.scrollValSecond, 
				behavior: "smooth" 
			});
			this.statisticScrollLeftShowSecond = true;
		},
		resize(){
			let w = document.getElementById('amountOfStatistical').clientWidth||document.getElementById('amountOfStatistical').offsetWidth;
			if(document.getElementById('amountOfStatistical').scrollWidth > w){
					this.statisticScrollRightShow = true;
				if(this.scrollValOne > 0){
					this.statisticScrollLeftShow = true;
				}				
			}else{
				this.statisticScrollLeftShow = false;
				this.statisticScrollRightShow = false;
			}
			let w2 = document.getElementById('cardStatistical').clientWidth||document.getElementById('cardStatistical').offsetWidth;
			if(document.getElementById('cardStatistical').scrollWidth > w2){
				this.statisticScrollRightShowSecond = true;
				if(this.scrollValSecond > 0){
					this.statisticScrollLeftShowSecond = true;
				}	
			}else{
				this.statisticScrollLeftShowSecond = false;
				this.statisticScrollRightShowSecond = false;
			}
		},
	},
	created(){
		 this.getDataHandle();
	},
	computed: {	},
	mounted(){
		// this.drawDiadram("sevenDaysDiagram");
		this.resize();
		window.onresize = () => {
			return (() => {
					this.resize();
			})();
		}
	},
}
</script>
<style lang="less" scoped>
.cardStatistical-row{
	.el-col-12{
		padding: 10px;
		::v-deep .grid-content {
			background: #FFFFFF;
			border-radius: 8px;
			.title{
				border-top-left-radius: 8px;
				border-top-right-radius: 8px;
				background: #D0E2FF;
				text-align:center;
				color:#19213F;
				font-size:14px;
				font-weight:bold;
				height:40px;
				line-height:40px;
			}
			.amountOfStatistical-bottom{
				display: flex;
				height:120px;
				align-items: center;
				.amountOfStatistical-bottom-item{
					position: relative;
					flex:1;
					text-align: center;
					p{
						color: #19213F;
						font-size:20px;
						padding-bottom:10px;
					}
					h2{
						font-size:14px;
						color:#636C88;
					}
					&::after{
						height:64px;
						width:1px;
						content: '';
						position: absolute;
						border-left:1px solid #E9E9E9;
						right: 0;
						top: 0;
						bottom: 0;
						margin: auto 0;
					}
					&:nth-child(3){
						&::after{
							border-left:0;
						}
					}
				}
			}
		}
	}
}
.amisarda{
	height:24px;
	color: #19213F;
	font-size:18px;
	font-weight:bold;
	margin-bottom:14px;
}
.amountOfStatistical{
	height: 145px;
	.scroll-div{
		.tag-defined{
			height:112px;
			display: flex;
			justify-content: space-between;
			.amountOfStatisticalItem{
				flex: 1;
				padding-right: 30px;
				>div{
					box-sizing: border-box;
					max-width:350px;
					min-width:260px;
					height:100px;
					background: #fff;
					border-radius:16px;
			        transition: .5s;


					h1{
						font-size:24px;
					}

					h2{
						font-size:16px;
					}

					p{
						font-size: 12px;
    					color: #AFB0BF;
					}


					.amountOfStatisticalItem-left{
						display:inline-block;
						width:5px;
						height:100%;
						float:left;
						border-radius: 4px 0 0 4px;
					}

					.amountOfStatisticalItem-right{
						display:inline-block;
						height:100%;
						// margin-left:25px;
						p{
							color:#D1D5E2;
							font-size:12px;
						}
						h2{
							margin-top:12px;
						}

						h2, p{
							margin-bottom:5px;
						}
					}

				}


				// >div:hover{
			    //     border: 1px solid #3490ee;
			    //     background: #ddf4ff;
			    //     transition: .5s;
			    // }
			}

			.amountOfStatisticalItem:last-child{
				padding-right: 0px;
			}

		}

	}

}
.cardStatistical{
	height: 150px;
	background:#fff;
	border-radius:16px;
	.el-divider--vertical{
		height: 59%;
		margin: 1.5% 0;
	}
	>div{
		>div{
			height: 170px;
			display: flex;
			justify-content: space-between;

			.amountOfStatistical-item{
				flex: 1;
				box-sizing: border-box;
				height: 155px;
				min-width: 350px;
				max-width: 400px;
				margin-right: 20px;
				transition: all .3s;
				.amountOfStatistical-top{
					box-sizing: border-box;
					height: 48px;
					h1{
						box-sizing: border-box;
						height:48px;
						line-height:48px;
						font-size: 18px;
						padding-left: 35px;
						margin-left: 10px;
					}
				}


				.amountOfStatistical-bottom-item{
					box-sizing: border-box;
					width: 33.3%;
					height:95px;
					float: left;
					text-align: center;
					font-size: 16px;

					p{
						display: inline-block;
						color: #333333;
						height: 50px;
						line-height: 50px;
						font-weight: bold;
						font-size: 18px;
					}

					h2{	
						height:45px;
						line-height:45px;
						font-size: 14px;
					}
				}
			}

			.amountOfStatistical-item:last-child{margin-right:0;}

			// .amountOfStatistical-item:hover{
			// 	transform: translate(0px,-5px); 
			// }
		}

	}
}



.icon-arrow-left, .icon-arrow-right{
	display: inline-block;
	width: 30px;
	line-height: 130px;
	vertical-align: top;
	font-size: 26px;
	text-align: center;
	transition: .5s;
	z-index: 100;
}

.icon-arrow-left:hover, .icon-arrow-right:hover{
	color: #409eff;
	transition: .3s;
}

.icon-arrow-left{
	position: absolute;
	left: 0;
	box-shadow: 10px 0px 10px #fff;
	background: #fff;
}

.icon-arrow-right{
	position: absolute;
	right: 0;
	box-shadow: -10px 0px 10px #fff;
	background: #fff;
}
.pointer{
	cursor: pointer;
}




.bottom-diagram{
	margin-top:14px;
	min-height:400px;
	display: flex;
	justify-content: space-between;
	background: #fff;
    padding: 10px;
    border-radius: 16px;
	.title{
		height:30px;
		margin-bottom: 10px;

		.decorations{
			display:inline-block;
			width: 26px;
			height:30px;
			margin-right: 10px;
			float: left;
			background: url(./../../assets/icon5.png) no-repeat center;
		}

		h4{
			display: inline-block;
			height: 30px;
			line-height: 30px;
			clear: both;
			font-size: 18px;
		}
	}

	.column-diagram{
		flex: 2;
		min-width: 700px;
		margin-right: 10px;

		>div{
			padding: 10px 20px;
			min-height:380px;
			border: 1px solid #d4d4d4;
			box-shadow: 5px 0px 5px #d4d4d4;
		}
	}

	.top-7{
		box-sizing: border-box;
		flex: 1;
		min-width: 506px;
		// padding: 10px 20px;
		min-height:370px;
		height: calc(100vh - 438px);
		// border: 1px solid #d4d4d4;
		// box-shadow: 5px 0px 5px #d4d4d4, 0px 5px 5px #d4d4d4;

		.sevenDaysDiagram{
			width:750px;
			min-height:370px;
		}
		/deep/.el-table__header-wrapper{
			/deep/.cell{
				font-size:14px;
				font-weight:bold;
			}
		}
	}
}


</style>